import React from 'react';
const OverrideLabel = _ref => {
  let {
    text,
    extraClass,
    infoButton
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: extraClass !== null && extraClass !== void 0 ? extraClass : ''
  }, infoButton !== null && infoButton !== void 0 ? infoButton : '', /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};
export default OverrideLabel;